import React from 'react';
import { ProductSelector } from './ProductSelector';
import type { SelectedItem, Product } from './ProductSelector';

export interface Artifact {
  artifactType: string;
  data: Record<string, unknown>;
  callbackAction?: string;
}

interface ArtifactRendererProps {
  artifact: Artifact;
  onAction: (action: string, data: unknown) => void;
}

export const ArtifactRenderer: React.FC<ArtifactRendererProps> = ({ artifact, onAction }) => {
  switch (artifact.artifactType) {
    case 'product_selector': {
      const products = (artifact.data.products || []) as Product[];
      const note = (artifact.data.note || '') as string;
      const action = artifact.callbackAction || 'request-quote';

      return (
        <ProductSelector
          products={products}
          note={note}
          onRequestQuote={(items: SelectedItem[]) => onAction(action, items)}
        />
      );
    }
    default:
      return null;
  }
};
